// NOTICE: KAPTION-INTEGRATION
//
// smart-assignment.MANUAL.6 — turns the manual endpoint's answer into the one line the
// person who pressed the key gets back.
//
// WHY a helper and not three lines inside the command handler: this is the only place the
// three outcomes are distinguished, and two of them are easy to get wrong. A fallback comes
// back as `assigned: false` exactly like a deliberate "nobody" — the difference is the
// reason token — and reporting an outage as "nobody was assigned" would teach agents to
// stop trusting the feature. The endpoint's first trace line is appended because it is the
// half of the answer that says WHY, and it is the half a supervisor quotes back at us.

// Must match Kaption::SmartAssignmentService::FALLBACK_REASON.
export const FALLBACK_REASON = 'fallback_native';

const firstTraceLine = result => {
  const lines = Array.isArray(result?.note_lines) ? result.note_lines : [];
  return lines.find(line => typeof line === 'string' && line.trim() !== '');
};

const headline = (result, t) => {
  if (result?.reason === FALLBACK_REASON) {
    return t('CONVERSATION.SMART_ASSIGNMENT.FALLBACK');
  }
  if (result?.assigned && result?.assignee?.name) {
    return t('CONVERSATION.SMART_ASSIGNMENT.ASSIGNED', {
      name: result.assignee.name,
    });
  }
  return t('CONVERSATION.SMART_ASSIGNMENT.NOT_ASSIGNED');
};

/**
 * The alert text for one manual smart-assignment run.
 *
 * @param {Object} result - the manual endpoint's JSON body
 * @param {Function} t - vue-i18n's translate function
 * @returns {string} e.g. "Asignado a Leonardo Ríos · Z1 de la ficha"
 */
export function smartAssignmentAlertMessage(result, t) {
  const trace = firstTraceLine(result);
  const message = headline(result, t);
  return trace ? `${message} · ${trace}` : message;
}
